import React from 'react'
import PropTypes from 'prop-types'
import {AspectRatio, Flex, Img, useStyleConfig} from '@chakra-ui/react'
import {EditorialVideo} from '../../video'
import useDamImage from '../../../../custom-hooks/use-dam-image'

export const OneMedia = ({media1}) => {
    const styles = useStyleConfig('Gallery')

    const damImage1 = useDamImage(media1?.image)

    return (
        <Flex className={'oneMediaLayout'} justifyContent={'center'}>
            {media1?.is_video ? (
                <EditorialVideo
                    data={media1?.video && media1?.video?.length ? media1?.video[0] : null}
                    data-testid="gallery-1-media"
                    {...styles.wideMedia}
                />
            ) : (
                (damImage1.url || media1?.image?.alt) && (
                    <AspectRatio ratio={damImage1.ratio} {...styles.wideMedia}>
                        <Img
                            src={damImage1.url}
                            alt={media1?.image?.alt || ''}
                            data-testid="gallery-1-media"
                        />
                    </AspectRatio>
                )
            )}
        </Flex>
    )
}

OneMedia.propTypes = {
    media1: PropTypes.shape({
        is_video: PropTypes.bool,
        video: PropTypes.arrayOf(PropTypes.shape()),
        image: PropTypes.shape(),
    }),
}
